import type { Operation, ResponseBody } from '@platform/openapi';
import { z } from 'zod';

export type TenantView = ResponseBody<Operation<'/admin/tenant', 'get'>>;

export const STORE_NAME_MAX_LENGTH = 200;

const MAGHREB_TIME_ZONES = ['Africa/Tunis', 'Africa/Algiers', 'Africa/Casablanca'] as const;

export const storeFormSchema = z.object({
  name: z.string().trim().min(1).max(STORE_NAME_MAX_LENGTH),
  defaultLocale: z.string().min(2),
  timezone: z.string().min(1),
});

export type StoreFormValues = z.infer<typeof storeFormSchema>;

export const storeFormOf = (tenant: TenantView): StoreFormValues => ({
  name: tenant.name,
  defaultLocale: tenant.locales[0] ?? '',
  timezone: tenant.timezone,
});

export const timeZoneChoicesOf = (current: string): readonly string[] =>
  MAGHREB_TIME_ZONES.some((zone) => zone === current) ? MAGHREB_TIME_ZONES : [...MAGHREB_TIME_ZONES, current];
